"use strict";
import { BigNumber } from "@ethersproject/bignumber";
import { parseUnits } from "@ethersproject/units";
import { CurrencyAmount } from "@uniswap/sdk-core";
import { convertScientificNotationToNumber } from "utilities/src/format/convertScientificNotation";
import { logger } from "utilities/src/logger/logger";
const ALL_NUMBERS_OR_SEPARATOR_REGEX = /^\d*\.?,?\d*$/;
export var ValueType = /* @__PURE__ */ ((ValueType2) => {
  ValueType2["Raw"] = "uint256";
  ValueType2["Exact"] = "float";
  return ValueType2;
})(ValueType || {});
export function getCurrencyAmount({
  value,
  valueType = "uint256" /* Raw */,
  currency
}) {
  if (!value || !currency) {
    return void 0;
  }
  try {
    let parsedValue = sanitizeTokenAmount({ value, valueType });
    if (valueType === "float" /* Exact */) {
      parsedValue = parseUnits(parsedValue, currency.decimals).toString();
    }
    return CurrencyAmount.fromRawAmount(currency, parsedValue);
  } catch (error) {
    logger.error(error, {
      tags: {
        file: "getCurrencyAmount",
        function: "getCurrencyAmount"
      },
      extra: {
        value,
        valueType,
        symbol: currency.symbol,
        chain: currency.chainId,
        address: currency.wrapped.address,
        decimals: currency.decimals
      }
    });
    return null;
  }
}
const sanitizeTokenAmount = ({ value, valueType }) => {
  let sanitizedValue = convertScientificNotationToNumber(value);
  if (sanitizedValue === ".") {
    sanitizedValue = "0.";
  }
  if (valueType === "float" /* Exact */ && !ALL_NUMBERS_OR_SEPARATOR_REGEX.test(sanitizedValue)) {
    throw new Error("Provided value is invalid");
  }
  if (valueType === "uint256" /* Raw */) {
    sanitizedValue = BigNumber.from(sanitizedValue).toString();
  }
  return sanitizedValue;
};
